export default __webpack_public_path__ + "static/media/info-atencion-vecino.eafca56f.svg";